<template>
  <b-container fluid>
    <h1 class="text-center">{{tituloPagina}}</h1>
    <hr>
    <button v-on:click="updateData">Actualizar</button>

    <highcharts :options="chartOptions"></highcharts>
  </b-container>
</template>

<script>
import LicenciaCargoPersonalSvc from "@/services/licenciacargopersonal";
import { Chart } from "highcharts-vue";
export default {
  name: "LicenciasByArticulo",
  components: {
    highcharts: Chart
  },
  data() {
    return {
      tituloPagina: "Licencias por Articulo ",
      arregloLicencias: [],
      chartOptions: {
        title: {
            text: 'Licencias por Articulo'
        },
        chart: {
          height: '100%',
          width: 1000,
          type: "bar",
          events: {
            redraw(event) {
              console.log("EVENT", event);
            }
          }
        },
        xAxis: {
            categories: [],
            crosshair: true
        },
        plotOptions: {
        column: {
            showInLegend: false,
            pointPadding: 0.2,
            borderWidth: 0,
            dataLabels: {
            allowOverlap: true,
            enabled: true
            },
        }
        },
        series: [
          {
            name: 'Cantidad de Licencias autorizadas',
            data: [] // sample data
          }
        ]
      }
    };
  },
  methods: {
    updateData() {
      LicenciaCargoPersonalSvc.getLista({ order: "desc", limit: 3000 })
        .then(response => {
          var articulosejex = [];
          var cantidadlicenciasejey = [];

          response.data.rows.forEach(f => {
            this.arregloLicencias.push(f);
          });
          console.log(this.arregloLicencias);
          var counts = this.arregloLicencias.reduce((p, c) => {
            var name =
              c.DetalleDiasLicencia.TipoLicencia.Articulo +
              "-" +
              c.DetalleDiasLicencia.Descripcion;
            if (!p.hasOwnProperty(name)) {
              p[name] = 0;
            }
            p[name]++;
            return p;
          }, {});
          console.log(counts);
          var cantidadlicenciasejey = Object.keys(counts).map(function(key) {
            return counts[key];
          });

          var articulosejex = Object.keys(counts).map(function(key) {
            return key;
          });
          console.log(cantidadlicenciasejey);
          console.log(articulosejex);
          this.chartOptions.series[0].data = cantidadlicenciasejey;
          this.chartOptions.xAxis.categories = articulosejex;
        })
        .catch(error => {
          console.log("No se encontro el listado ", error);
        });
    }
  },
  watch: {
    title(newValue) {
      this.chartOptions.title.text = newValue;
    },
    points(newValue) {
      this.chartOptions.series[0].data = newValue;
    },
    chartType(newValue) {
      this.chartOptions.chart.type = newValue.toLowerCase();
    },
    seriesColor(newValue) {
      this.chartOptions.series[0].color = newValue.toLowerCase();
    },
    animationDuration(newValue) {
      this.updateArgs[2].duration = Number(newValue);
    }
  },
  created() {}
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/reportes/LicenciasByArticulo.vue